type FlagTypes = 'boolean' | 'number' | 'string' | 'enum' | 'json';

type FlagDefinition<TType extends FlagTypes = FlagTypes, TOutput = unknown> = {
  key: string;
  type: TType;
  // this is a weird type because we mostly want wider types
  // but enums should be more specific
  defaultValue: TType extends 'boolean'
    ? boolean
    : TType extends 'number'
      ? number
      : TType extends 'string'
        ? string
        : TType extends 'enum'
          ? TOutput
          : unknown;
};

/**
 * Helper function that validates flag definitions
 */
export const defineFlagDefinitions = <T extends Record<string, FlagDefinition>>(flags: T) => flags;
